import { Navigate, Route, Routes } from 'react-router-dom';

import QuestionnaireIntroduction from '../common/components/QuestionnaireIntroduction';
import { INTAKE_INTRODUCTION_VIDEO_POSTER, INTAKE_INTRODUCTION_VIDEO_SRC } from '../common/constants';
import { GeneralInformationForm } from './components/forms/general';
import { MedicalForm } from './components/forms/medical';
import { MedicationForm } from './components/forms/medication';
import { ReferralForm } from './components/forms/referral';
import { TherapyForm } from './components/forms/therapy';
import { EducationForm } from './components/forms/education';
import { FamilyForm } from './components/forms/family';
import { ClientInfoForm } from './components/forms/clientInfo';
import SubmitForm from './components/forms/SubmitForm';
import { INTAKE_TAB_IDS } from './constants';

export default function IntakeQuestionnaireRoutes() {
  return (
    <Routes>
      <Route
        path={INTAKE_TAB_IDS.INTRODUCTION}
        element={
          <QuestionnaireIntroduction
            src={INTAKE_INTRODUCTION_VIDEO_SRC}
            poster={INTAKE_INTRODUCTION_VIDEO_POSTER}
          />
        }
      />
      <Route index element={<Navigate replace to={INTAKE_TAB_IDS.INTRODUCTION} />} />
      <Route path={INTAKE_TAB_IDS.GENERAL} element={<GeneralInformationForm />} />
      <Route path={INTAKE_TAB_IDS.MEDICAL} element={<MedicalForm />} />
      <Route path={INTAKE_TAB_IDS.MEDICATION} element={<MedicationForm />} />
      <Route path={INTAKE_TAB_IDS.REFERRAL} element={<ReferralForm />} />
      <Route path={INTAKE_TAB_IDS.THERAPY} element={<TherapyForm />} />
      <Route path={INTAKE_TAB_IDS.EDUCATION} element={<EducationForm />} />
      <Route path={INTAKE_TAB_IDS.FAMILY} element={<FamilyForm />} />
      <Route path={INTAKE_TAB_IDS.CHILD} element={<ClientInfoForm />} />
      <Route path={INTAKE_TAB_IDS.SUBMIT} element={<SubmitForm />} />
      <Route path="*" element={<Navigate replace to={INTAKE_TAB_IDS.INTRODUCTION} />} />
    </Routes>
  );
}
